import React, { useEffect } from 'react';

import { Row, Col, InputControl, ButtonGroup, Button, SegmentLoader } from '@si-armes/dsfr-react';

import InputFiles from 'components/Commun/Form/InputFiles';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { getPath } from 'utils/router';
import { useDispatch, useSelector } from 'react-redux';
import { postAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_MODIFIER_NOMBRE_ADHERENT,
    CONTEXT_API_MODIFIER_NOMBRE_ADHERENT,
} from 'constants/apiUrls.constants';
import FileUploadeBack from 'components/form/InputFiles/Model/FileUploadeBack';
import { CODE_STATUS_200 } from 'constants/codeStatusHttp.constants';
import RoutesEcranGestion from '../gestion/routes';

const NombreLicenciesAdherents = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { data: dataInfoPerso = {} } = useSelector(
        (state) => state.monCompte.recupererInformationsPersonnelles || {},
    );

    const {
        isLoading: isLoadingModifierNombreAdherent = false,
        data: dataModifierNombreAdherent,
        codeStatut: codeStatutModifierNombreAdherent,
    } = useSelector((state) => state.monCompte.modifierNombreAdherent || {});

    const {
        id = null,
        editable = false,
        nombreAdherent = null,
        justificatifAdherent = {},
        historiqueAdherentStatut = null,
    } = dataInfoPerso?.personnePhysique?.informationsMetiersAssociations?.adherents || {};

    const isACompleter = historiqueAdherentStatut === 'a-completer';

    const hookForm = useForm({
        mode: 'onChange',
    });

    const { handleSubmit, register, reset, formState } = hookForm;
    const { isValid } = formState;

    const redirectToEcranGestion = async () => {
        await dispatch(reinitialiseAPI(CONTEXT_API_MODIFIER_NOMBRE_ADHERENT));
        history.push(getPath(RoutesEcranGestion));
    };

    const onSubmit = async (dataForm) => {
        if (dataForm) {
            const params = {
                id: isACompleter ? id : null,
                nombreAdherent: Number(dataForm?.nombreAdherent),
                justificatif: dataForm.justificatifNombreAdherent?.[0]
                    ? await dataForm.justificatifNombreAdherent[0].getFileToSend()
                    : null,
            };

            dispatch(
                postAPI(
                    usagerClientReducer,
                    API_MODIFIER_NOMBRE_ADHERENT,
                    params,
                    CONTEXT_API_MODIFIER_NOMBRE_ADHERENT,
                ),
            );
        }
    };

    useEffect(() => {
        const params = { nombreAdherent };

        if (justificatifAdherent?.uuid && !editable && !isACompleter) {
            const justificatifNombreAdherent = new FileUploadeBack({
                filename: justificatifAdherent?.libelleUtilisateur,
                uuid: justificatifAdherent?.uuid,
            });

            params.justificatifNombreAdherent = [justificatifNombreAdherent];
        }

        reset(params);
    }, [nombreAdherent, justificatifAdherent, isACompleter]);

    useEffect(() => {
        if (dataModifierNombreAdherent && codeStatutModifierNombreAdherent === CODE_STATUS_200) {
            redirectToEcranGestion();
        }
    }, [dataModifierNombreAdherent, codeStatutModifierNombreAdherent]);

    return (
        <SegmentLoader isLoading={isLoadingModifierNombreAdherent}>
            <FormProvider {...hookForm}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Row gutters className="margin-bottom-sm">
                        <Col col={12} md={6}>
                            <InputControl
                                id="nombreAdherent"
                                name="nombreAdherent"
                                label="Nombre de licenciés ou adhérents"
                                disabled={!editable}
                                {...register('nombreAdherent', {
                                    required: true,
                                    pattern: {
                                        value: /^[0-9]+$/,
                                        message: 'Veuillez entrer un nombre valide',
                                    },
                                })}
                                state={formState.errors?.nombreAdherent ? 'error' : null}
                                message={formState.errors?.nombreAdherent?.message}
                            />
                        </Col>

                        <Col col={12} md={6}>
                            <InputFiles
                                name="justificatifNombreAdherent"
                                label="Justificatif"
                                texteAide={null}
                                required
                                disabled={!editable && !isACompleter}
                            />
                            {isACompleter && (
                                <>
                                    <span className="fr-error">
                                        Merci de compléter votre nombre d'adhérent en renseignant un
                                        nouveau justificatif.
                                    </span>
                                </>
                            )}
                        </Col>
                    </Row>
                    <Row className="margin-top-lg">
                        <Col col={12}>
                            <ButtonGroup align="right" inline>
                                <Button
                                    name="retour"
                                    variant="secondary"
                                    onClick={redirectToEcranGestion}
                                >
                                    Retour
                                </Button>
                                <Button
                                    name="valider"
                                    variant="primary"
                                    type="submit"
                                    disabled={!isValid || (!editable && !isACompleter)}
                                >
                                    Enregistrer les modifications
                                </Button>
                            </ButtonGroup>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </SegmentLoader>
    );
};

export default NombreLicenciesAdherents;
